import {Badge} from 'react-bootstrap'
import {KTIcon} from '../../../../_metronic/helpers'
import FormikControl from '../../../../components/formikControl/FormikControl'
import {useChatContext} from '../Context'
import {filterStudentsByClassAndDivision} from '../service'

function StudentSelector({
  selectedClass = '',
  selectedDivision = '',
}: {
  selectedClass: string
  selectedDivision: string
}) {
  const {data} = useChatContext()
  const {students, classes, divisions} = data

  const filteredStudents = filterStudentsByClassAndDivision({
    students,
    selectedClass,
    selectedDivision,
  })

  return (
    <>
      <div className="d-flex gap-2">
        <Badge bg="light">
          <KTIcon iconName="filter" className="fs-2 text-info" />
        </Badge>
        {/* filters */}
        <FormikControl
          control={'select-advanced'}
          options={classes}
          name="class_Name"
          placeholder="Class"
          optionLabel={'class_name'}
          optionValue={'class_name'}
          size="sm"
          className="w-50"
        />
        <FormikControl
          control={'select-advanced'}
          options={divisions}
          name="divisionName"
          placeholder="Division"
          optionLabel={'division_name'}
          optionValue={'division_name'}
          size="sm"
          className="w-50"
        />
      </div>
      {/* Students list */}
      <FormikControl
        control="select-advanced"
        options={filteredStudents}
        optionLabel="student_name"
        optionValue="student_id"
        name="studentIds"
        label="Select Recipient Students"
        className="mt-4"
        size="sm"
        isMulti
      />
    </>
  )
}

export default StudentSelector
